import React, { useState, useCallback } from 'react';
import { Col } from 'react-bootstrap';
import ReactECharts from 'components/ThemedECharts';
import { Charts } from 'types/Meteorology/Agro/CultureIndex/Location/getCharts';
import DoubleSlider from 'components/DesignSystem/Slider/DoubleSlider';
import { getDataZoomConfig } from './chartConfig';

import './index.scss';

export default function LocationCharts({
  options,
  containerRef,
}: {
  options: Charts[];
  containerRef: React.RefObject<HTMLDivElement | null>;
}) {
  const [zoomStart, setZoomStart] = useState(0);
  const [zoomEnd, setZoomEnd] = useState(100);

  const setZoom = useCallback(
    ([start, end]: number[]) => {
      setZoomStart(start);
      setZoomEnd(end);
    },
    [setZoomStart, setZoomEnd],
  );

  return (
    <Col>
      <div className="index-location-chart-container" ref={containerRef}>
        {options.map((option, index) => {
          const keyTitle = (option.title as { text: string } | undefined)?.text;

          return (
            <div key={keyTitle || `chart-${index}`} className="position-relative w-100 mt-5" style={{ height: '30rem' }}>
              <div className="position-absolute top-0 left-0 w-100 h-100">
                <ReactECharts
                  className="h-100"
                  option={{
                    ...option,
                    title: {
                      ...(typeof option.title === 'object' ? option.title : {}),
                      left: 'center',
                      top: 0,
                    },
                    grid: {
                      left: '5%',
                      right: '10%',
                      bottom: 20,
                      top: 90,
                      containLabel: true,
                    },
                    dataZoom: getDataZoomConfig(zoomStart, zoomEnd, 0),
                    animation: false,
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="index-location-x-slider">
        <DoubleSlider
          min={0}
          max={100}
          value={[zoomStart, zoomEnd]}
          setValue={setZoom}
        />
      </div>
    </Col>
  );
}
